<!--
 * @Author: chenxing
 * @Date: 2021-05-17 15:54:34
 * @LastEditors: Yran
 * @LastEditTime: 2022-02-11 17:21:35
-->
<template>
  <div class="page_access_warpeer w100 h100">
    <!-- 处理按钮 -->
    <a-row class="filter_row">
      <a-col :span="24">
        <a-form-item label="" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" style="margin-bottom: 16px">
          <a-button type="primary" @click="addAccess" :disabled="tableLoading">
            <template #icon>
              <PlusOutlined />
            </template>
            新增
          </a-button>
          <a-divider type="vertical"></a-divider>
          <a-button type="primary" :disabled="selectedRowKeys.length === 0" @click="deleteModalVisible = true">
            <template #icon>
              <DeleteOutlined />
            </template>
            删除
          </a-button>
        </a-form-item>
      </a-col>
    </a-row>

    <div class="table_wrapper">
      <a-table :key="accessData.accessSource.length" default-expand-all-rows children-column-name="list" size="small" :data-source="accessData.accessSource" :scroll="{ y: 200 }" :columns="accessData.columns" :row-key="record => record.menuId" :default-expanded-row-keys="expandRowKeys" :pagination="accessPagination" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :loading="tableLoading" bordered :custom-row="record => customClickRow(record)" @change="changeTable">
        <template #icon="{ record }">
          <span><component class="mr20" :is="$antIcons[record.icon]" />{{ record.icon }}</span>
        </template>
        <template #watermark="{ record }">
          <span v-if="record.watermark === 1">显示</span>
          <span v-else>不显示</span>
        </template>
        <template #operation="{ record }">
          <a @click.stop="editAccess(record)" class="mr10">编辑</a>
        </template>
      </a-table>
    </div>

    <a-modal class="accessModal" v-model:visible="accessModalVisible" :title="accessModalTitle" :mask-closable="false" @ok="columnMap(modalOptions, modalFlag)()" @cancel="onaccessModalCancel" cancel-text="取消" ok-text="确认">
      <a-form ref="accessFormRef" :rules="accessModalRules" :model="accessModalData">
        <a-form-item label="菜单名称" :label-col="labelCol" :wrapper-col="wrapperCol" name="name">
          <a-input v-model:value="accessModalData.name" placeholder="请输入菜单名称" :disabled="accessDisable" />
        </a-form-item>
        <a-form-item label="父级菜单ID" :label-col="labelCol" :wrapper-col="wrapperCol" name="parentId">
          <a-input v-model:value.number="accessModalData.parentId" placeholder="请输入父级菜单ID" :disabled="accessDisable" />
        </a-form-item>
        <a-form-item label="菜单类型" :label-col="labelCol" :wrapper-col="wrapperCol" name="type">
          <a-select v-model:value="accessModalData.type" placeholder="请选择菜单类型" :disabled="accessDisable">
            <a-select-option :value="0">目录</a-select-option>
            <a-select-option :value="1">菜单</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="false" label="图标" :label-col="labelCol" :wrapper-col="wrapperCol" name="icon">
          <a-select v-model:value="accessModalData.icon" placeholder="请选择图标" style="width: 100%" ref="select" :disabled="accessDisable" allow-clear show-search>
            <template #notFoundContent>
              <a-empty :image="simpleImage">
                <template #description>
                  <span>暂无数据</span>
                </template>
              </a-empty>
            </template>
            <a-select-option v-for="item in accessIconsList" :value="item.key" :key="item.key">
              <span><component class="mr20" :is="$antIcons[item.key]" />{{ item.key }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="菜单URL" :label-col="labelCol" :wrapper-col="wrapperCol" class="mb10" name="url">
          <a-input v-model:value="accessModalData.url" placeholder="请输入菜单URL" :disabled="accessDisable" />
        </a-form-item>
        <a-form-item label="显示水印" :label-col="labelCol" :wrapper-col="wrapperCol" class="mb10" name="watermark">
          <a-radio-group :options="watermarkOptions" v-model:value="accessModalData.watermark" :disabled="accessDisable" />
        </a-form-item>
        <a-form-item label="是否渲染" :label-col="labelCol" :wrapper-col="wrapperCol" class="mb10" name="watermark">
          <a-radio-group v-model:value="accessModalData.isShow">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal class="deleteModal" v-model:visible="deleteModalVisible" title="确认删除" :mask-closable="false" @ok="deleteAccess" @cancel="deleteModalVisible = false" cancel-text="取消" ok-text="确认">
      <span>此操作不可逆，是否确认删除选中菜单？</span>
    </a-modal>
  </div>
</template>

<script>
import locale from 'ant-design-vue/lib/locale-provider/zh_CN';
import { Empty } from 'ant-design-vue';
import { PlusOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import { getMenuList, saveMenu, updateMenu, deleteMenu } from '@/api/systemManage/menuManage.js';
export default {
  data() {
    return {
      expandRowKeys: [],
      locale,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      // 客户数据集合
      accessData: {
        columns: [
          { title: '菜单ID', dataIndex: 'menuId' },
          { title: '菜单名称', dataIndex: 'name' },
          { title: '图标', width: '6.06rem', dataIndex: 'icon', slots: { customRender: 'icon' } },
          { title: '水印显示', width: '6.06rem', dataIndex: 'watermark', slots: { customRender: 'watermark' } },
          { title: '菜单URL', dataIndex: 'url' },
          { title: '操作', width: '4.55rem', dataIndex: 'operation', slots: { customRender: 'operation' } },
        ],
        accessSource: [],
      },
      // 菜单表格分页配置
      accessPagination: {
        total: 0,
        limit: '30',
        page: '1',
        pageSize: 30,
        showTotal: total => `总计${total}条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
      },
      // 表格加载
      tableLoading: false,
      // 选中的表格行
      selectedRowKeys: [],
      // 新增编辑菜单弹窗
      accessModalVisible: false,
      // 菜单标题
      accessModalTitle: '',
      // 菜单弹窗数据
      accessModalData: {},
      // 弹窗是否禁止编辑
      accessDisable: false,
      // 菜单图标新增icon
      newIcon: '',
      // 菜单图标列表
      accessIconsList: [{ key: 'ApartmentOutlined' }, { key: 'DashboardOutlined' }, { key: 'TeamOutlined' }, { key: 'BarChartOutlined' }, { key: 'FileTextOutlined' }, { key: 'FundOutlined' }, { key: 'UserOutlined' }],
      // 删除菜单确认弹窗
      deleteModalVisible: false,
      // 菜单弹窗校验
      accessModalRules: {
        name: [{ required: true, message: '请选择菜单名称', trigger: 'blur' }],
        parentId: [{ required: true, type: 'number', message: '请输入父级菜单ID', trigger: 'blur' }],
        upAccessName: [{ required: true, message: '请选择上级菜单名称', trigger: 'blur' }],
        // icon: [{ required: true, message: '请选择图标', trigger: 'blur' }],
        type: [{ required: true, type: 'number', message: '请选择类型名称', trigger: 'blur' }],
        soltNum: [{ required: true, message: '请选择排序号', trigger: 'blur' }],
        url: [{ required: true, message: '请输入菜单URL', trigger: 'blur' }],
        watermark: [{ required: true, type: 'number', message: '请设置是否显示水印', trigger: 'blur' }],
      },
      // 是否显示水印选项
      watermarkOptions: [
        { label: '显示', value: 1 },
        { label: '不显示', value: 0 },
      ],
      // 会话框确认方法配置
      modalOptions: [
        { text: this.saveAddAccess, value: 'addAccess' },
        { text: this.saveEditAccess, value: 'editAccess' },
      ],
      labelCol: { sm: { span: 6 }, md: { span: 6 }, lg: { span: 6 }, xl: { span: 6 }, xxl: { span: 4 } },
      wrapperCol: { sm: { span: 16 }, md: { span: 16 }, lg: { span: 16 }, xl: { span: 16 }, xxl: { span: 18 } },
    };
  },
  components: {
    PlusOutlined,
    FormOutlined,
    DeleteOutlined,
  },
  created() {
    this.getMenuList();
  },
  methods: {
    /** 表格页码切换
     * @param {*}
     * @return {*}
     */
    changeTable(pagination) {
      this.accessPagination.limit = pagination.pageSize.toString();
      this.accessPagination.pageSize = pagination.pageSize;
      this.accessPagination.page = pagination.current.toString();
      this.getMenuList();
    },
    /** 获取菜单列表
     * @param {*}
     * @return {*}
     */
    getMenuList() {
      this.tableLoading = true;
      let params = {
        ...this.accessPagination,
      };
      getMenuList(params).then(res => {
        // 获取数据条数
        this.accessPagination.total = 0;
        const treeToList = data => {
          data.forEach(item => {
            this.accessPagination.total++;
            if (item.list?.length) {
              // treeToList(item.list);
            } else {
              delete item.list;
            }
          });
        };
        treeToList(res.list);
        this.accessPagination.total;
        this.accessData.accessSource = res.list;
        this.tableLoading = false;
      });
    },

    /** 打开新增菜单弹窗
     * @param {*}
     * @return {*}
     */
    addAccess() {
      this.accessModalData = {
        watermark: 1,
        isShow: 1,
      };
      this.modalFlag = 'addAccess';
      this.accessModalVisible = true;
      this.accessModalTitle = '新增菜单';
    },

    /** 新增菜单确认
     * @param {*}
     * @return {*}
     */
    async saveAddAccess() {
      await this.$refs.accessFormRef.validate().then(() => {
        saveMenu(this.accessModalData).then(res => {
          if (res.code === 0) {
            this.$message.success('新增菜单成功！');
            this.onaccessModalCancel();
            this.getMenuList();
          }
        });
      });
    },

    /** 打开编辑菜单弹窗
     * @param {Object} seleteRow 选中的行
     * @return {*}
     */
    editAccess(seleteRow) {
      this.selectedRowKeys = [seleteRow.menuId];
      this.modalFlag = 'editAccess';
      this.accessModalVisible = true;
      this.accessModalData = seleteRow;
      this.accessModalTitle = '编辑菜单';
    },

    /** 编辑菜单确认
     * @param {*}
     * @return {*}
     */
    async saveEditAccess() {
      await this.$refs.accessFormRef.validate().then(() => {
        updateMenu(this.accessModalData).then(res => {
          if (res.code === 0) {
            this.$message.success('编辑菜单成功！');
            this.onaccessModalCancel();
            this.getMenuList();
          }
        });
      });
    },

    /** 删除菜单
     * @param {*}
     * @return {*}
     */
    async deleteAccess() {
      let res = await deleteMenu({ menuIdList: this.selectedRowKeys });
      if (res.code === 0) {
        this.$message.success('删除菜单成功！');
        this.onaccessModalCancel();
        this.deleteModalVisible = false;
        this.getMenuList();
      }
    },

    /** 数据字典映射
     * @param {Array} optionlist 数据配置列表
     * @param {String}} key 匹配的key值
     * @return {*}
     */
    columnMap(optionlist, key) {
      if (key) {
        return optionlist.filter(item => {
          return item.value == key;
        })[0].text;
      }
    },

    /** 点击表格行
     * @param {*} record 点击的行数据
     * @return {*}
     */
    customClickRow(record) {
      return {
        onClick: event => {
          let indexOfIndex = this.selectedRowKeys.indexOf(record.menuId);
          if (indexOfIndex !== -1) {
            this.selectedRowKeys.splice(indexOfIndex, 1);
          } else {
            this.selectedRowKeys.push(record.menuId);
          }
        },
      };
    },

    /** 复选框选中变化事件
     * @param {Array} selectedRowKeys 已选中的行
     * @return {*}
     */
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    /** 新增编辑框关闭
     * @param {*}
     * @return {*}
     */
    onaccessModalCancel() {
      this.accessModalData = {};
      this.selectedRowKeys = [];
      this.accessModalVisible = false;
    },

    /** 菜单名称输入框失去焦点
     * @param {*}
     * @return {*}
     */
    nameBlur() {
      let name = this.accessModalData.name;
      if (name && (name[0] === ' ' || name[name.length - 1] === ' ')) {
        this.$message.warning('请不要在菜单名称前后输入空格！');
      }
      this.accessModalData.name = this.accessModalData.name && this.accessModalData.name.trim();
    },
  },
};
</script>

<style lang="less">
.page_access_warpeer {
  display: flex;
  flex-direction: column;
  .ant-table-scroll .ant-table-body {
    max-height: calc(100vh - 270px) !important;
  }
}
</style>